import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import {
  IOAuthDetails,
  IVendorConnectConfirmation,
  IVendorConnectInitRequest,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import {
  callbackDomain,
  VendorIdSource
} from '@portal/app/dashboard/integrations/shared/constants';
import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { WindowService } from '@portal/app/shared/services/window.service';
import { map } from 'lodash-es';

export class RedditHandler implements VendorHandler {
  constructor(
    private storageService: StorageService,
    private windowService: WindowService
  ) {}

  prepareRequestObjectToInitiateVendor(
    vendorDetails: IVendorConnectInitRequest
  ): IVendorInitiateRequest {
    console.warn('Reddit handler', vendorDetails);
    return {
      req: {},
      queryParams: { callbackDomain: callbackDomain() },
      pathParams: { vendorId: VendorIdSource.reddit }
    };
  }

  prepareRequestObjectToConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string;
      disabled: boolean;
    }[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.reddit,
      vendorData: map(accounts, (account) => ({
        accountId: account.accountId
      }))
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    localStorage.setItem(
      'callBackParams',
      JSON.stringify(
        (data.vendorCredentialsDetails as IOAuthDetails).callbackParameters
      )
    );
    this.windowService.navigateToHref(
      (data.vendorCredentialsDetails as IOAuthDetails).redirectURL
    );
  }

  confirmVendor(data: IVendorConnectConfirmation): void {
    const jsonData = data.accountDetails
      ? JSON.stringify(data.accountDetails.vendorAccounts)
      : '';
    this.storageService.setIntegrationAccountDetails(
      VendorIdSource.reddit,
      jsonData
    );
  }

  prepareRequestToConfirmVendor(): IVendorOAuthConfirmationRequest {
    return {
      code: `${localStorage.getItem('code')}`,
      state: `${localStorage.getItem('state')}`,
      callbackDomain: callbackDomain()
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string;
      disabled: boolean;
    }[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.reddit,
      vendorData: map(accounts, (account) => ({
        accountId: account.accountId
      })),
      dsInstanceIds
    };
  }
}
